import { CONSTANTS_GENERATION__value_range as CONSTANTS } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { DTO_GRAPH__instance } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__instance';
import { DTO__number_range } from '@shared/dto/generation/settings/DTO__number_range';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD_PRIMITIVE__int } from '../../../../_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { ENUM__image_asset_category } from '../../../../_fields/ENUM__image_asset_category';
import { FIELD__image_asset } from '../../../../_fields/image/FIELD__image_asset';
import { ENUM__invocation_type } from '../../../_base/ENUM__invocation_type';
import { INVOCATION_VISION__base_cv2 } from '../../_base/INVOCATION_VISION__base_cv2';

export class INVOCATION_VISION_CV2__control_line_guidance_canny extends INVOCATION_VISION__base_cv2 {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.INVOCATION_VISION_CV2__LINE__CANNY;

  /*
   * FIELDS
   */
  @FIELD__image_asset.init_as_input({ category: ENUM__image_asset_category.IMAGE }, { field_role: '🖼️ Image' })
  image!: FIELD__image_asset;

  @FIELD_PRIMITIVE__int.init_as_input(
    {
      value: 100,
      value_range: new DTO__number_range(CONSTANTS.COLOR.min, 128),
      values_allowed: CONSTANTS.COLOR,
      //
      slider_step: 64,
      slider_step_values: [8, 16, 32, 64],
    },
    { field_role: '🎚️ Threshold Low' },
  )
  threshold_low!: FIELD_PRIMITIVE__int;

  @FIELD_PRIMITIVE__int.init_as_input(
    {
      value: 200,
      value_range: new DTO__number_range(128, CONSTANTS.COLOR.max),
      values_allowed: CONSTANTS.COLOR,
      //
      slider_step: 64,
      slider_step_values: [8, 16, 32, 64],
    },
    { field_role: '🎚️ Threshold High' },
  )
  threshold_high!: FIELD_PRIMITIVE__int;

  /*
   * OUTPUT
   */

  @FIELD__image_asset.init_as_output({ category: ENUM__image_asset_category.LINE__CANNY })
  out!: FIELD__image_asset;

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.VISION_CV2__LINE__CANNY);
  }

  prepare_for_usage_in(graph: DTO_GRAPH__instance) {
    super.prepare_for_usage_in(graph);

    this.threshold_low.sync_with_field_max(this.threshold_high);
  }
}
